import PropTypes from 'prop-types';

export const COMPETITION_PROP_TYPES = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const COMPETITIONS_PROP_TYPES = PropTypes.arrayOf(COMPETITION_PROP_TYPES);
